/**
 * Stops GA4 from collecting data on /admin/* routes (our own traffic).
 *
 * GA4 respects `window['ga-disable-<MEASUREMENT_ID>'] = true` for every hit
 * sent through gtag.js, which covers nuxt-gtag, vue-gtag-next and GTM's GA4 tags
 * when they use the same measurement ID.
 *
 * The flag is also set synchronously from an inline head script (see nuxt.config.ts)
 * so the very first page_view on a direct /admin load is skipped. This plugin
 * keeps it in sync on client-side navigation. It is named 00.* so it registers
 * its router guard before the other analytics plugins' router hooks.
 */
export default defineNuxtPlugin(() => {
  const gaId = useRuntimeConfig().public.gaMeasurementId as string
  if (!gaId) return

  const key = `ga-disable-${gaId}`
  const apply = (path: string) => {
    ;(window as any)[key] = path === '/admin' || path.startsWith('/admin/')
  }

  apply(window.location.pathname)
  useRouter().beforeEach((to) => {
    apply(to.path)
  })
})
